<template>
    <div>
        <div style="color: #00ff96;font-size: 1rem">转移申请</div>
          <form :form="form">
              <div style="display: flex;justify-content: space-between;">
                  <SelectField labelWidth="40%" label="申请人" style="margin: 0.5rem 0.2rem;width:45%" id="applicantId"
                               :modelValue="form.applicantId" :options="userList" required
                               @update:modelValue="(value) => handleModelValueUpdate('applicantId', value)"
                  />
                  <DatePickerField labelWidth="40%" label="申请时间" required style="margin: 0.1rem 0.1rem 0.1rem 0;width:45%"
                                   id="transferTime"
                                   name="transferTime" placeholder="请选择日期"
                                   :rules="[{ required: true, message: '请选择日期' }]"
                                   v-model="form.transferTime"
                                   @update:modelValue="(value) => handleModelValueUpdate('transferTime', value)"
                  />
              </div>
              <div>
                  <TextareaField :value="form.reason" id="reason" required labelWidth="14%" style="margin: 0.5rem 0.2rem" label="转移原因"
                                 @update:modelValue="(value) => handleModelValueUpdate('reason', value)"
                  />
                  <TextareaField :value="form.remark" labelWidth="14%" style="margin: 0.5rem 0.2rem" label="备注"
                                 id="remark"  @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                  />
              </div>
              <div class="formDiv">
                  <div style="display: flex;justify-content: start">
                      <div style="width:10%;margin:1rem 0 1rem 1rem;color:#8290a7;">附件</div>
                      <Upload :list="fileList" @change="(list) => (fileList = list)" />
                  </div>
              </div>
              <div class="formDiv">
                  <Goods :selected="selected" @close-add-modal="handleCloseAddModal"/>
              </div>
              <div class="formButton">
                  <a-space>
                      <ButtonField text="关闭" @click="cancel" secondary />
                      <ButtonField text="保存" primary @click="handleSubmit"/>
                  </a-space>
              </div>
          </form>
      </div>
</template>

<script>
import { add } from "../api/transfer";
import Goods from "./components/goods.vue";
import { mapState } from "vuex";
export default {
    components: {
        Goods
    },

    data() {
        return {
            form: {
                applicantId:null,
                transferTime:null,
                reason:null,
                remark:null
            },
            selected: [],
            fileList: [],
            loading: false,
            visible:true,
        };
    },
    pops:{
        visible: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        ...mapState("userSelector", ["userList"]),
    },

    methods: {
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        handleFilesUploaded(files) {
            console.log("上传的文件：", files);
            // 在这里处理上传的文件
        },
        handleSubmit() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            if (!this.form.applicantId) {
                this.$message.error('申请人不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.transferTime) {
                this.$message.error('申请时间不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.reason) {
                this.$message.error('申请原因不能为空');
                this.isSubmitting = false;
                return;
            }
            add({
                ...this.form,
                applicant: this.userList.find(
                    (item) => item.id === this.form.applicantId
                ).name,
                ransferTime: this.form.transferTime.format("YYYY-MM-DD"),
                materialList: this.selected.map((item) => {
                    return {
                        mid: item.id,
                        code: item.code,
                        name: item.name,
                        brand: item.brand,
                        specification: item.specification,
                        unit: item.unit,
                        price: item.price,
                        chargerOldId: item.chargerId,
                        chargerOld: item.charger,
                        chargerNewId: item.chargerNewId,
                        chargerNew: this.userList.find(
                            (element) => element.id === item.chargerNewId
                        )?.name,
                    };
                }),
                attachments: this.fileList.map((item) => item.id).join(","),
            })
                .then(() => {
                    this.cancel();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$emit('show-transfer-index');
        },
        handleCloseAddModal() {
            this.visible = false;
        }
    },
};
</script>
<style scoped>
.formButton{
    width: 100%;
    text-align: center;
    margin-top:1.5rem;
}
</style>
